import { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase";
import { Link } from "react-router-dom";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleReset(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await sendPasswordResetEmail(auth, email);
      setSent(true);
    } catch (err) {
      if (err.code === "auth/user-not-found") {
        setError("No account found with that email address.");
      } else if (err.code === "auth/invalid-email") {
        setError("Please enter a valid email address.");
      } else {
        setError("Something went wrong. Please try again.");
      }
    }
    setLoading(false);
  }

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: "#0A0B0F" }}>
      <div className="w-full max-w-md mx-auto px-6">

        <div className="text-center mb-8">
          <Link to="/login">
            <span className="font-display text-3xl tracking-wider" style={{ color: "#C8FF00" }}>
              PREDICTORZ.
            </span>
          </Link>
        </div>

        <div className="rounded-2xl p-8" style={{ backgroundColor: "#141519", border: "1px solid #1E2028" }}>

          {sent ? (
            <div className="text-center">
              <div className="text-5xl mb-4">📧</div>
              <h2 className="font-display text-4xl tracking-wider mb-3" style={{ color: "#FFFFFF" }}>
                EMAIL SENT
              </h2>
              <p className="font-condensed text-gray-400 tracking-wide mb-2">
                We've sent a password reset link to:
              </p>
              <p className="font-condensed text-lg mb-6" style={{ color: "#C8FF00" }}>
                {email}
              </p>
              <div className="px-4 py-3 rounded-xl font-condensed tracking-wide text-sm mb-6"
                style={{ backgroundColor: "#1A1B20", border: "1px solid #2A2B30", color: "#888" }}>
                ⚠ Check your spam folder if you don't see it within a few minutes
              </div>
              <Link
                to="/login"
                className="btn-lime w-full py-3 rounded-xl text-lg block text-center"
              >
                BACK TO LOGIN
              </Link>
            </div>
          ) : (
            <>
              <h2 className="font-display text-4xl tracking-wider mb-2" style={{ color: "#FFFFFF" }}>
                RESET PASSWORD
              </h2>
              <p className="font-condensed text-gray-400 tracking-wide mb-8">
                Enter your email and we'll send you a reset link
              </p>

              {error && (
                <div className="mb-6 px-4 py-3 rounded-lg font-condensed tracking-wide text-red-400"
                  style={{ backgroundColor: "#1A0A0A", border: "1px solid #3A1A1A" }}>
                  {error}
                </div>
              )}

              <form onSubmit={handleReset} className="space-y-4">
                <div>
                  <label className="font-condensed text-gray-400 tracking-widest text-sm uppercase block mb-2">
                    Email Address
                  </label>
                  <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full rounded-xl px-4 py-3 text-lg"
                    placeholder="your@email.com"
                  />
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="btn-lime w-full py-4 rounded-xl text-xl"
                >
                  {loading ? "SENDING..." : "SEND RESET LINK"}
                </button>
              </form>

              <p className="font-condensed text-gray-500 text-center mt-6 tracking-wide">
                Remember your password?{" "}
                <Link to="/login" className="hover:underline" style={{ color: "#C8FF00" }}>
                  Log in
                </Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}